<template>
  <div>
      <el-row>
      <el-col :span="24">
        <el-button
          style="padding: 0; margin: 20px"
          type="text"
          icon="el-icon-back"
          @click="$router.go(-1)"
        >
          返回
        </el-button>
        <el-button type="primary" :disabled="addProductVisible" size="mini" @click="addProductDialog()">
          添加
        </el-button>
      </el-col>
    </el-row>

    <el-row>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0"
      >
        <el-table-column prop="product_id" label="ID" align="center" min-width="6%"></el-table-column>
        <el-table-column
          prop="title"
          label="标题"
          align="center"
          min-width="20%"
        ></el-table-column>
        <el-table-column label="图片" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <img :src="row.img_url" style="width: 40px" alt="" />
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" min-width="10%">
          <template slot-scope="{ row }">
            <el-button
              type="danger"
              size="mini"
              @click="activityDeleteProduct(row.id)"
              :disabled="addProductVisible"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>

    <!-- 商品推荐添加商品 -->
    <el-dialog
      title="选择商品"
      :visible.sync="search.chooseOrgVisible"
      :close-on-click-modal="true"
      :before-close="addEditFormOnClose"
      width="75%"
    >
      <el-form :inline="true" :model="search.query">
        <!-- 模糊查询 -->
        <el-form-item label="商品标题">
          <el-input
            size="small"
            v-model="search.query.search"
            placeholder="请输入标题"
            clearable
            @blur="searchData()"
          />
        </el-form-item>
        <el-form-item label="供应商">
          <el-input
              size="small"
              v-model="search.query.vendor"
              placeholder="请输入供应商"
              clearable
              @blur="searchData()"
          />
        </el-form-item>
        <el-form-item label="售卖价">
          <el-input
              size="small"
              v-model="search.query.price_start"
              placeholder="售卖价开始"
              clearable
              @blur="searchData()"
              type="number"
              min="0"
          />
        </el-form-item>
        <el-form-item>
          <el-input
              size="small"
              v-model="search.query.price_end"
              placeholder="售卖价结束"
              clearable
              @blur="searchData()"
              type="number"
              min="0"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="
              searchData();
            "
          >
            查询
          </el-button>
        </el-form-item>
      </el-form>

      <!--列表-->
      <el-table
        border
        ref="multipleTable"
        :data="search.result.data"
        highlight-current-row
        v-loading="search.listLoading1"
        style="..."
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="id" label="ID" align="center"></el-table-column>
        <el-table-column
          prop="title"
          label="标题"
          align="center"
        ></el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="{ row }">
            <img :src="row.img_url" style="width: 40px" alt="" />
          </template>
        </el-table-column>
        <el-table-column
            prop="vendor"
            label="供应商"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="price"
            label="售卖价"
            align="center"
        ></el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="searchData"
        :current-page.sync="search.query.page"
        :page-sizes="[5, 100, 500, 1000]"
        :page-size="search.query.limit"
        layout="total, prev, pager, next, jumper,sizes"
        :total="search.result.total"
      >
      </el-pagination>
      <div style="margin-top: 20px">
        <el-button @click="activityAddProduct()"
          >确定</el-button
        >
<!--        <el-button @click="toggleSelection()">取消选择</el-button>-->
      </div>
    </el-dialog>
  </div>
</template>

<script>

import {
  activityProductList,
  getProductList,
  activityAddProduct,
  activityDeleteProduct
} from "@/api/productActivity";

export default {
  data: function () {
    return {
      ossAction: "",
      dialogVisible: false,
      type: 1,
      list: [],
      loading: false,
      total: 0,
      updateLoading: false,
      addProductVisible: false,
      partake_product:this.$route.query.partake_product,
      query: {
        id: this.$route.query.activity_id,
        page: 1,
        limit: 20,
      },
      search: {
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          search: "",
          vendor: "",
          price_start: "",
          price_end: "",
          page: 1,
          limit: 5,
          id: this.$route.query.activity_id,
        },
        result: {
          total: 0,
          data: [],
        },
      },
      addProduct: {
          id: this.$route.query.activity_id,
          productIds: []
      },
    };
  },
  created: function () {
    this.type = this.$route.query.type;
    if(this.type == 2){
      this.addProductVisible = true;
    }
    this.getList();
  },
  methods: {
    addProductDialog() {
      var title = '';
      if(this.partake_product == 'assign'){
        title = '添加的商品”参加“活动';
      }else{
        title = '添加的商品”不参加“活动';
      }
      this.$confirm(title, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showCancelButton: false,
        type: 'warning'
      }).then(() => {
        this.addProduct.productIds = [];
        this.search.chooseOrgVisible = true;
        this.searchData();
      }).catch(() => {

      });

    },
    // 弹窗关闭
    addEditFormOnClose() {
      this.search.query.page = 1;
      this.search.query.search = "";
      this.search.result = {
        total: 0,
        data: [],
      };
      this.search.chooseOrgVisible = false;
      this.addProduct.productIds = [];
    },
    // 查询方法
    searchData() {
      this.search.listLoading1 = true;
      getProductList(this.search.query).then((response) => {
        this.search.result.data = response.data.list;
        this.search.result.total = response.data.total;
        this.search.listLoading1 = false;
      });
    },
    handleSelectionChange(rows) {
        this.addProduct.productIds = [];
        rows.forEach(row => {
            this.addProduct.productIds.push(row.id);
        });
    },
    /*toggleSelection(){
      this.addProduct.productIds = [];
    },*/
    activityAddProduct() {
      activityAddProduct(this.addProduct)
        .then((response) => {
          this.updateLoading = false;
          if (response.status == 2000) {
            this.$message.success(response.message);
            this.addEditFormOnClose();
            this.getList();
          }
        })
        .catch((err) => {
          this.updateLoading = false;
        });
    },

    getList() {
      this.loading = true;
      activityProductList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },
    activityDeleteProduct(id) {
      this.$confirm("此操作将删除该对象, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        activityDeleteProduct({
          id: id,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },
    handleSizeChange(val) {
      this.search.query.limit = val;
      this.searchData();
    },
  },
}
</script>

<style>

</style>